<template>
  <div class="overflow-hidden rs-slider"
    ref="container"
    @mousedown="startdrag('mouse', $event)"
    @touchstart="startdrag('touch', $event)"
  >
    <div class="rs-slider-inner overflow-hidden w-full flex" v-if="ready" ref="slider" :style="{ 'will-change': 'transform', transform: `translate3D(${Math.floor(translate)}px,0,0)`, width: `${innerWidth}px` }">
      <slot />
    </div>
    <div class="flex justify-center" v-if="slideCount">
      <span class="rounded-full m-1 w-3 h-3 bg-secondary_text" style="will-change: opacity" @click="goto(i-1)" :class="{'opacity-25': (i-1) !== index}" v-for="i in slideCount" :key="i"></span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    pageDots: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      touchType: null,
      touching: false,
      startx: 0,
      wishedX: 0,
      translate: 0,
      translateStart: 0,
      translateMax: 100,
      ready: false,
      innerWidth: 100,
      outerWidth: 100,
      lastDx: 0,
      magnetPos: 0,
      afhandle: null,
      flickSign: 0,
      index: 0,
      slideCount: 1,
      resizeObserver: null,
    }
  },
  mounted() {
    const vpW = this.$refs.container.clientWidth
    this.$refs.container.style.setProperty('--vp-w', vpW + 'px')
    this.outerWidth = vpW
    this.innerWidth = vpW
    this.ready = true
    this.$nextTick(() => {
      const count = this.$refs.slider.childElementCount
      this.slideCount = count
      this.innerWidth = count * vpW
      this.translateMax = -(count - 1) * vpW
    })

    this.resizeObserver = new ResizeObserver(() => {
      const vpW = this.$refs.container.clientWidth
      this.$refs.container.style.setProperty('--vp-w', vpW + 'px')
      this.outerWidth = vpW
      this.innerWidth = this.slideCount * vpW
      this.translateMax = -(this.slideCount - 1) * vpW
      this.translate = -this.index * vpW
    })
    this.resizeObserver.observe(this.$refs.container)
  },
  beforeDestroy() {
    this.resizeObserver.disconnect()
  },
  methods: {
    tick() {
      const before = this.translate
      let calc = before
      let distanceToMagnet = 0

      if(this.touching) {
        //manual
        calc = this.wishedX
      } else {
        //simulated
        calc = before + this.lastDx

        if(Math.sign(before - this.magnetPos) != Math.sign(calc - this.magnetPos)) {
          calc = this.magnetPos
        }
      }

      calc = Math.max(Math.min(calc, 0), this.translateMax)

      if(!this.touching) {
        distanceToMagnet = this.magnetPos - calc
        calc += distanceToMagnet * .02
      } else {
        this.flickSign = Math.sign(before - calc)
      }

      this.translate = calc

      this.lastDx = this.translate - before
      if(this.touching || Math.abs(this.lastDx) >= .1) {
        this.afhandle = requestAnimationFrame(this.tick.bind(this))
      }
      this.index = Math.round(-calc / this.outerWidth)
   },
    startdrag(type, event) {
      if(!this.touching) {
        this.touchType = type
        this.touching = true
        this.translateStart = this.translate
        this.wishedX = this.translate

        if(type === 'touch') {
          this.startx = event.touches[0].screenX
          window.addEventListener('touchend', this.stopdrag)
          window.addEventListener('touchmove', this.move)
        } else {
          this.startx = event.screenX
          window.addEventListener('mousemove', this.move)
          window.addEventListener('mouseup', this.stopdrag)
        }
        
        cancelAnimationFrame(this.afhandle)
        this.afhandle = requestAnimationFrame(this.tick.bind(this))
      }
    },

    move(event) {
      let x = 0
      if(this.touchType === 'touch') {
        x = event.touches[0].screenX
      } else {
        x = event.screenX
      }
      
      const dx = this.startx - x
      this.wishedX = this.translateStart - dx
    },

    goto(index) {
      this.magnetPos = -index * this.outerWidth
      cancelAnimationFrame(this.afhandle)
      this.afhandle = requestAnimationFrame(this.tick.bind(this))
    },

    next() {
      if(this.index < this.slideCount - 1) {
        this.goto(this.index + 1)
      }
    },

    prev() {
      if(this.index > 0) {
        this.goto(this.index - 1)
      }
    },

    stopdrag(event) {
      if(!this.touching) return

      if(this.touchType === 'touch') {
        window.removeEventListener('touchend', this.stopdrag)
        window.removeEventListener('touchmove', this.move)
        event.preventDefault() 
      } else {
        window.removeEventListener('mouseup', this.stopdrag)
        window.removeEventListener('mousemove', this.move)
        event.preventDefault() 
      }

      let magnetBias = 'round'
      if(this.flickSign > 0) {
        magnetBias = 'floor'
      } else if(this.flickSign < 0) {
        magnetBias = 'ceil'
      }

      const magnetPos = Math[magnetBias](this.translate / this.outerWidth) * this.outerWidth
      this.magnetPos = magnetPos

      this.touching = false
      this.touchType = null
    }
  }
}
</script>

<style>
.rs-slider {
  @apply select-none;
  touch-action: pan-y;
}


.rs-slider-inner > * {
  @apply flex-shrink-0;
  width: var(--vp-w);

}
</style>